import { ParentBlockSelectField } from '../../ConfigFields/SelectField';

export function OutputBlockFormFields() {
  return (
    <ParentBlockSelectField
      label="Data to output"
      fieldName="config.data"
      helperText="Choose what data you want the subflow to return to the parent flow"
    />
  );
}
